import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import IntlMessage from '../../../../helpers/intlMessage';

function Grid({
  lista,
  pagina,
  totalItens,
  totalItensPage,
  setPagina,
  onclickLine
}) {
  function Footer({ totalItens }) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center'
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center'
          }}
        >
          <i
            className='mv-basico-stacktrace'
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }}>
            <IntlMessage id="general.requestsPanel.totalExams" />: {totalItens}
          </span>
        </span>
      </div>
    );
  }
  return (
    <Card>
      <CardBody>
        <Container fluid>
          <DataTable
            onContextMenu={e => onclickLine(e)}
            value={lista}
            responsive={true}
            selectionMode='single'
            style={{ height: '100%' }}
            columnResizeMode='expand'
            scrollable={true}
            scrollWidth='100%'
            resizableColumns={lista.length >= 1}
            reorderableColumns={lista.length >= 1}
            first={(pagina - 1) * totalItensPage}
            rows={totalItensPage}
            lazy={true}
            paginator={lista.length > 0}
            emptyMessage={<IntlMessage id="general.requestsPanel.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
            totalRecords={totalItens}
            onPage={event => setPagina(event.page + 1)}
            footer={<Footer totalItens={totalItens} />}
          >
            <Column sortable={false} field='select' style={{ width: '25px' }} />

            <Column field='nrExame' style={{ width: '100px' }} header={<IntlMessage id="dashboards.examDetail.table.exam" />} />
            <Column
              field='paciente'
              style={{ width: '200px' }}
              header={<IntlMessage id="general.requestsPanel.patient" />}
            />
            <Column field='medico' style={{ width: '200px' }} header={<IntlMessage id="dashboards.reports.doctor" />} />
            <Column field='exame' style={{ width: '250px' }} header={<IntlMessage id="dashboards.reports.type" />} />

            <Column
              field='dataPedido'
              style={{ width: '150px' }}
              header={<IntlMessage id="general.requestsPanel.requestDate" />}
            />
            <Column
              field='prontuario'
              style={{ width: '120px' }}
              header={<IntlMessage id="general.requestsPanel.medicalRecord" />}
            />
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

export default Grid;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Laudos/Grid/index.js